import { configureApiClient } from '@train-tracks/shared/api';

/**
 * Resolve the base URL the web app's API client should use.
 *
 * A *cross-origin absolute* base (e.g. the Render API host while the app is
 * served from Netlify) makes the session cookie a third-party cookie. Safari
 * / iOS drop those unconditionally (ITP), and Chrome/Firefox increasingly do
 * too — so the cookie is never stored, the first authenticated request 401s,
 * and sign-in silently fails to stick. In production the API is reverse-proxied
 * under the app's own origin (Netlify rewrite → Render; see
 * docs/deploy.md → "Same-origin API proxy"), so we force a same-origin
 * (relative) base there and ignore any stale absolute `VITE_API_URL`. Local
 * dev still points at a separate backend host.
 */
export function resolveApiBaseUrl(rawApiUrl: string | undefined, isProd: boolean): string {
  const raw = (rawApiUrl ?? '').trim();
  const isCrossOriginAbsolute = /^https?:\/\//i.test(raw);
  if (isProd && isCrossOriginAbsolute) return '';
  return raw;
}

const env = import.meta.env as { VITE_API_URL?: string };

export const apiBaseUrl: string = resolveApiBaseUrl(env.VITE_API_URL, import.meta.env.PROD);

// Point the shared api singleton at the web app's backend. The shared
// package is platform-agnostic and never reads `import.meta.env` itself, so
// each host injects its own base URL here (mobile does the equivalent with
// `process.env.EXPO_PUBLIC_API_URL`).
configureApiClient(apiBaseUrl);
